export * from "./boots.svg";
export * from "./sandals.svg";

export const z = 3;
